import React from 'react'

import PropTypes from 'prop-types'
import { isEmpty } from 'lodash'
import { Checkbox } from '@material-ui/core'

import useBulkSelection from 'hooks/useBulkSelection'

const BulkSelectionAllCheckbox = ({ label }) => {
  const { items, allSelected, someSelected, toggleAll } = useBulkSelection()

  return (
    <Checkbox
      indeterminate={someSelected}
      checked={allSelected}
      onChange={toggleAll}
      disabled={isEmpty(items)}
      inputProps={{ 'aria-label': label }}
    />
  )
}

BulkSelectionAllCheckbox.propTypes = {
  label: PropTypes.string,
}

export default BulkSelectionAllCheckbox
